import actions from './actions.js'
import mutations from './mutations.js'
import getInitState from './get-init-state.js'
import previewer from './previewer/index.js'
import model from './model/index.ts'

const configure = {
  namespaced: true,
  state: getInitState(),
  mutations: mutations,
  actions: actions,
  modules: {
    previewer,
    model,
  },
}

export default configure
